import React from 'react';
import { motion } from 'framer-motion';
import { LegalDoc } from '../../data/legalDocs';
import { LegalCard } from './LegalCard';

interface LegalSectionProps {
  title: string;
  docs: LegalDoc[];
  index: number;
}

export const LegalSection: React.FC<LegalSectionProps> = ({ title, docs, index }) => {
  if (docs.length === 0) return null;

  return (
    <section className="mb-20 md:mb-28">
      <motion.h3
        className="text-2xl md:text-3xl font-semibold text-white/90 mb-8 md:mb-10"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.6,
          delay: index * 0.15,
          ease: [0.25, 0.1, 0.25, 1],
        }}
      >
        {title}
      </motion.h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {docs.map((doc, docIndex) => (
          <LegalCard key={doc.id} doc={doc} index={docIndex} />
        ))}
      </div>
    </section>
  );
};
